var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-bar",style:(_vm.height ? 'height:' + _vm.height : '')},[_c('div',{staticClass:"charts-bar-chart__canvas",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }